// Zone5.js
import React from 'react';
import mirrorImg from '../ZonetablePoster/Mirror.png'; 
import '../ZonetablePoster/allzones.css';

const videoLinks = [
  { title: "The PRUTL TIME-STORM (Hindi)", link: "https://youtu.be/YBArDaaJ8OU" },
  { title: "The PRUTL TIME-STORM (English)", link: "https://youtu.be/U_QaUxCNZRA" },
  { title: "When Hearts Whisper Again (Hindi)", link: "https://youtu.be/Enuq1xT9UXk" },
  { title: "When Hearts Whisper Again (English)", link: "https://youtu.be/CZHYfUqxKZc" },
  { title: "EMI-e-motion (Hindi)", link: "https://youtu.be/qennA44PvXI" },
  { title: "EMI-e-motion (English)", link: "https://youtu.be/kZfMbTFSxoc" },
  { title: "The Last Bus to Kailash (Hindi)", link: "https://youtu.be/a3jL5UPBM5I" },
  { title: "The Last Bus to Kailash (English)", link: "https://youtu.be/a6WrLlh_hWs" },
  { title: "THE MIRROR OF ERIS (Hindi)", link: "https://youtu.be/7Pnpv6w0GxM" },
  { title: "THE MIRROR OF ERIS (English)", link: "https://youtu.be/NzI0uLhU9F8" }
];

const tableData = [
  {
    picture: mirrorImg,
     title: "THE MIRROR OF ERIS — Possessed or Awakened",
    genre: "Horror | Psychological Thriller | Multi-faith Redemption Drama"
  }
];

function Zone5() {
  return (
    <div style={{ backgroundColor: 'black', minHeight: '100vh', padding: '20px' }}>
      <h1 className="zone-title">Zone 5</h1>

      <table className="zone-table">
        <thead>
          <tr>
            <th>Museo Series</th>
            <th>Title</th>
            <th>Genre</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, idx) => (
            <tr key={idx}>
              <td><img src={item.picture} alt={item.title} /></td>
              <td className="title">{item.title}</td>
              <td className="genre">{item.genre}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Videos Grid */}
      <div className="episodes-grid" style={{ marginTop: '40px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {videoLinks.map((video, index) => (
          <div key={index} className="episode-card" style={{ backgroundColor: '#111', padding: '10px', borderRadius: '8px' }}>
            <div className="episode-thumbnail" style={{ height: '180px' }}>
              <iframe
                width="100%"
                height="100%"
                src={video.link.replace("youtu.be/", "www.youtube.com/embed/")}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ borderRadius: '6px' }}
              ></iframe>
            </div>
            <div className="episode-title" style={{ marginTop: '8px', color: 'white', textAlign: 'center' }}>
              {video.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Zone5;
